import { fromJS, setIn, isImmutable } from 'immutable';
import { REDUCERS_TO_PERSISTS } from '../reducers';
import storage from '../common/storage';

export function getStorageKeyForReducer(reducerName, statePath) {
  let pathString = '';
  if (statePath != null) {
    pathString = `.${statePath.join('.')}`;
  }
  return `state.${reducerName}${pathString}`;
}

export function reHydrateRootStateFromStorage() {
  return REDUCERS_TO_PERSISTS.map(({ name, initialState, statePath }) => {
    // TODO: set up async rehydration, and remove `getSync`
    const subState = storage.getSync(getStorageKeyForReducer(name, statePath));

    if (subState == null) {
      // set undefined in order to skip reHydrating
      return { [name]: undefined };
    }

    // merge persisted on top of initialState in order to keep persisted state updated
    // when initialState structure is changed
    const state = statePath
      ? fromJS(setIn({}, statePath, subState))
      : fromJS(subState);

    return { [name]: initialState.mergeDeep(state) };
  }).reduce((state, partialState) => Object.assign(state, partialState));
}

export function createPersistToStorageMiddleware() {
  const writeStateToStorage = async (state) => {
    REDUCERS_TO_PERSISTS.forEach(({ name, statePath }) => {
      const key = getStorageKeyForReducer(name, statePath);
      if (statePath == null) {
        storage.set(key, state[name].toJS());
      } else {
        let partialState = state[name].getIn(statePath);
        if (isImmutable(partialState)) {
          partialState = partialState.toJS();
        }
        storage.set(key, partialState);
      }
    });
  };

  return ({ getState }) =>
    (next) =>
    (action) => {
      const result = next(action);
      writeStateToStorage(getState());
      return result;
    };
}
